/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useToast } from "@/hooks/use-toast";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { useForm } from "react-hook-form";

import { z } from "zod";

type UseUserformType = {
  formData: any;
  onFormSubmit: (prop: any) => Promise<any>;
};

const formSchema = z.object({
  company_name: z.string().readonly().optional(),
  country: z.string().optional(),
  email: z.string().email(),
  phone: z.string(),
  username: z.string().readonly().optional(),
});

export const useReactForm = ({
  formData,
  onFormSubmit,
}: // open,
UseUserformType) => {
  const { toast } = useToast();
  const schemaKeys = formSchema.keyof().options;

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    mode: "onBlur",
    defaultValues: {
      company_name: formData.company_name || "",
      country: formData.country || "",
      email: formData.email || "",
      phone: formData.phone || "",
      username: formData.username || "",
    },
  });

  useEffect(() => {
    if (formData && Object.keys(formData).length > 0) {
      schemaKeys.forEach((key) => {
        if (formData[key]) {
          form.setValue(key, formData[key], {
            shouldTouch: true,
            shouldDirty: true,
          });
        }
      });
    }
  }, [formData]);

  async function onSubmit(values: z.infer<typeof formSchema>) {
    const { data } = await onFormSubmit(values);
    if (data) {
      toast({
        title: "Success",
        variant: "success",
        description: data.status.msg,
      });
    }
  }

  return { form, onSubmit };
};
